import { FunctionComponent } from "react";
import styles from "./JoinParticipantScreen.module.css";

const JoinParticipantScreen: FunctionComponent = () => {
  return (
    <div className={styles.joinParticipantScreen}>
      <div className={styles.masterScreen}>
        <div className={styles.masterScreenChild} />
        <div className={styles.masterScreenItem} />
        <div className={styles.byManaberaiAllRightsContainer}>
          © 2025  by
          <a
            className={styles.manaberai}
            href="https://themeforest.net/user/ib-themes"
            target="_blank"
          >
            <span className={styles.manaberai1}>manaber.ai</span>
          </a>
          . All rights reserved.
        </div>
        <img
          className={styles.manaberlogoCopy3}
          alt=""
          src="/manaberlogo--copy-3@2x.png"
        />
        <img className={styles.govOfShj3Icon} alt="" src="/govofshj-3@2x.png" />
      </div>
      <div className={styles.speaker}>
        <div className={styles.speakerChild} />
        <div className={styles.buttonJoinConference}>
          <img className={styles.vectorIcon} alt="" src="/vector10.svg" />
          <b className={styles.join}>{`Join `}</b>
        </div>
        <img className={styles.image51Icon} alt="" src="/image-51@2x.png" />
      </div>
      <div className={styles.translateToLangugae}>
        <img className={styles.image53Icon} alt="" src="/image-53@2x.png" />
        <div className={styles.translateToLaguage}>Translate to laguage</div>
      </div>
      <b className={styles.welcomeToAl}>Welcome to: Al Sharjah Mosque</b>
    </div>
  );
};

export default JoinParticipantScreen;
